import Vue from 'vue'
import VueRouter from 'vue-router'

//app entry
const Contact = () => import('@/views/Contact.vue')
const Edwork = () => import("@/views/home/Edwork.vue")
// const Hero = () => import("@/views/home/Hero.vue")
const Login = () => import('@/views/authentication/Login.vue')

//modules
import forum from './modules/forum'
import authentication from "./modules/authentication"
import policies from './modules/policies'
import user from './modules/user'
import utils from './modules/utils'
import quiz from './modules/quiz'
import read from './modules/read'



Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    component: Edwork,
    children: [

      {
        path: '',
        name: "home",
        component: Login
      },
      {
        path: '/contact',
        name: 'contact',
        component: Contact
      },
      ...authentication,//authentication routes
      ...policies,//privacy and cookie policies
    ]
  },


  forum, //forum
  user,
  quiz,
  read,
  ...utils
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
